import styled, { css } from 'styled-components';
import { ArticleCardStyled } from '../article/KnowledgeStyles';

export const DashboardContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-top: 1.5rem;

    @media (min-width: 768px) {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
        gap: 1.5rem;
    }
`;

export const FeatureCard = styled.div`
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.borderColor};
    border-radius: ${({ theme }) => theme.borderRadius};
    box-shadow: ${({ theme }) => theme.shadows.sm};
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    position: relative;

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0.75rem;

    .card-icon-wrapper {
        position: static;
        flex-shrink: 0;
        width: 44px; height: 44px;
        margin-right: 1rem;
        background-color: ${({ theme }) => theme.colors.primaryLightest};
        color: ${({ theme }) => theme.colors.primary};
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        svg { width: 24px; height: 24px; }
    }
    .card-content {
        flex-grow: 1;
        h3 { font-size: 1rem; margin-bottom: 0.1rem; color: ${({ theme }) => theme.colors.textDark}; }
        p { font-size: 0.8rem; color: ${({ theme }) => theme.colors.textMedium}; line-height: 1.3; }
    }
    .card-action-indicator {
        margin-left: auto;
        color: ${({ theme }) => theme.colors.textDisabled};
        padding-left: 0.5rem;
    }

    @media (min-width: 768px) {
        background: linear-gradient(135deg, ${({ theme }) => theme.colors.white} 0%, ${({ theme }) => theme.colors.background} 100%);
        box-shadow: ${({ theme }) => theme.shadows.md};
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        padding: 1.5rem;
        min-height: 180px;

        .card-icon-wrapper {
            position: absolute; top: 1.5rem; right: 1.5rem;
            width: 52px; height: 52px;
            border-radius: 50%;
            svg { width: 28px; height: 28px; }
        }
        .card-content {
            max-width: calc(100% - 70px);
            h3 { font-size: 1.375rem; color: ${({ theme }) => theme.colors.primaryDarker}; margin-bottom: 0.5rem; }
            p { font-size: 0.9rem; line-height: 1.5; }
        }
        .card-action-indicator { align-self: flex-end; margin-left: 0; margin-top: 1rem; }
    }

    &:hover {
        border-color: ${({ theme }) => theme.colors.primaryLight};
        .card-action-indicator { color: ${({ theme }) => theme.colors.primary}; }
        @media (min-width: 768px) {
            transform: translateY(-4px) scale(1.02);
            box-shadow: ${({ theme }) => theme.shadows.xl};
        }
    }

    ${({ $disabled }) => $disabled && css`
        cursor: not-allowed; background: ${({ theme }) => theme.colors.neutralLight};
        .card-content h3, .card-content p, .card-icon-wrapper { opacity: 0.6; }
        &:hover {
            border-color: ${({ theme }) => theme.colors.borderColor};
            box-shadow: ${({ theme }) => theme.shadows.sm};
            transform: none;
            @media (min-width: 768px) { box-shadow: ${({ theme }) => theme.shadows.md}; }
            .card-action-indicator { color: ${({ theme }) => theme.colors.textDisabled}; }
        }
    `}
`;

export const ArticlesSection = styled.section`
    margin-top: 2.5rem;
    padding-top: 2rem;
    border-top: 1px solid ${({ theme }) => theme.colors.borderColor};

    h2 {
        text-align: center;
        font-weight: 700;
        color: ${({ theme }) => theme.colors.primaryDarker};
        margin-bottom: 1.5rem;
        font-size: 1.3rem;
        @media(min-width: 768px) {
            text-align: left;
            font-size: 1.6rem;
        }
    }

    .desktop-slider { display: none; }
    .mobile-slider { display: block; }
    @media (min-width: 768px) {
        .desktop-slider { display: block; }
        .mobile-slider { display: none; }
    }

    .swiper-vertical-custom {
        height: 320px;
        /* POPRAWKA: Usunięcie paddingu, który powodował przesunięcie w lewo */
        /* padding-right: 1.5rem; */
    }
    .swiper-pagination-vertical.swiper-pagination-bullets, .swiper-vertical > .swiper-pagination-bullets {
        /* Pozycjonowanie paginacji, aby nie wpływała na layout slajdów */
        right: 0.5rem;
        top: 50%;
        transform: translateY(-50%);
    }

    .desktop-slider .swiper {
        padding: 0.5rem;
        padding-bottom: 3rem;
    }
    .desktop-slider .swiper-button-next,
    .desktop-slider .swiper-button-prev {
        color: ${({ theme }) => theme.colors.primary};
    }
    .desktop-slider .swiper-pagination-bullet-active {
        background: ${({ theme }) => theme.colors.primary};
    }

    ${ArticleCardStyled} {
        /* BAZA (MOBILE): Horyzontalna, kompaktowa karta */
        width: 100%; max-width: none; margin: 0;
        height: 100px; min-height: 100px;
        display: flex; flex-direction: row;
        align-items: stretch; /* Dzieci wypełniają wysokość */
        padding: 0; overflow: hidden;

        .article-card-image, .article-image-placeholder {
            width: 100px; /* Stała szerokość obrazka */
            height: 100%;
            flex-shrink: 0; object-fit: cover;
            border-radius: ${({ theme }) => theme.borderRadius} 0 0 ${({ theme }) => theme.borderRadius};
        }
        .article-card-content {
            padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
            display: flex; flex-direction: column;
            justify-content: center; flex-grow: 1;
            h3 { font-size: 0.9rem; line-height: 1.2; margin-bottom: 0.25rem; }
            .article-category { font-size: 0.7rem; }
            .article-snippet { display: none; } /* Snippet ukryty na mobile */
        }

        /* WEB (DESKTOP): Horyzontalna, ale większa karta */
        @media (min-width: 768px) {
            height: 140px; min-height: 140px;

            .article-card-image, .article-image-placeholder {
                width: 140px;
            }

            .article-card-content {
                justify-content: space-evenly;
                h3 { font-size: 1.1rem; }
                .article-snippet {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden; text-overflow: ellipsis;
                    font-size: 0.85rem;
                }
            }
        }
    }
`;